// external imports
import { QueryType } from 'typegraph';

// internal imports
import { Status } from 'common/constants/Constants';
import IService from 'core/service/IService';
import Class from 'core/util/Class';
import ConfigUtil from 'core/util/config/ConfigUtil';

export enum QueryAlias {
	ONE = "entity",
	MANY = "entities"
}

export interface IBaseResult {
	status: Status;
}

export interface IOneResult<T> extends IBaseResult {
	entity: T;
}

export interface IQueryMeta {
	start: number; // beginning of the page
	end: number; // end of the page
	total: number; // total number of records
	pageSize: number; // number of records per page
	pageIndex: number; // page index zero based
	totalPages: number; // total page count based on total rows and page size
}

export interface IManyResult<T> extends IBaseResult {
	status: Status;
	entities: T[];
	meta: IQueryMeta;
	next: object; // params to get the next page
	previous: object; // params to get the previous page
}

export interface IRootResult<T> extends IBaseResult {
	data: T;
}

export default abstract class IQueryService implements IService {
	protected static DEFAULT_ID: string = "default";
	private static CONFIG_FIELD: string = "service.query";
	private static REGISTRY: string = "api:query";

	public getRegistry(): string {
		return IQueryService.REGISTRY;
	}

	public getActive(): string {
		return ConfigUtil.getString(IQueryService.CONFIG_FIELD, IQueryService.DEFAULT_ID);
	}

	public getConditions = () => undefined;

	public abstract findOne<T>(entity: Class<T>, params: object, variables?: object): Promise<IOneResult<T>>;

	public abstract findMany<T>(entity: Class<T>, params: object, variables?: object): Promise<IManyResult<T>>;

	public abstract find(type: QueryType, entity: Class<any>, params: object | any, variables?: object): Promise<any>;

	public abstract load<T>(operationClazz: Class<T>, data: object | any, variables?: object): Promise<IRootResult<T>>;

	public abstract getServiceId(): string;

	protected static parseManyResponse<T>(promise: Promise<any>, entityName: string): Promise<IManyResult<T>> {

		// validate the response

		// the promise pipeline, this is step 2 of it

		// create the paging result and set the paging:
		return promise.then((response) => {

			const restult: IManyResult<T> = {

				// add the actual data
				entities: response.entities.entityName,

				// add paging information
				...response.meta.entityName.pagingInfo,

				// add request status
				status: response.meta.entityName.status,
			};

			return restult;
		});
	}
}



// WEBPACK FOOTER //
// ./src/core/service/query/IQueryService.ts